import { render, staticRenderFns } from "./addAddressDialog.vue?vue&type=template&id=1faadd4e&scoped=true"
import script from "./addAddressDialog.vue?vue&type=script&lang=ts"
export * from "./addAddressDialog.vue?vue&type=script&lang=ts"
import style0 from "./addAddressDialog.vue?vue&type=style&index=0&id=1faadd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faadd4e",
  null
  
)

export default component.exports